<template>
  <span
    v-if="badgeLabel"
    class="badge badge-pill rounded-pill"
    :class="badgeClass"
  >
    {{ badgeLabel }}
  </span>
</template>
<script>
export default {
  name: 'AmendmentBadge',
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  computed: {
    badgeLabel() {
      if (this.contract.status === 'ARCHIVED') {
        return 'Version archivée';
      }

      return '';
    },
    badgeClass() {
      if (this.contract.status === 'ARCHIVED') {
        return 'bg-yellow-300 text-blue-700';
      }

      return 'bg-blue-300 text-blue-700';
    },
  },
};
</script>
